import React from 'react'
import { makeMobileNav } from './styled'
import PropTypes from 'prop-types'
import FlexContainer from '../../../shared/flex-container'
import MobileNavItem from './mobile-nav-item'

export const RawMobileNav = makeMobileNav('div')

const menu = [
  {
    path: '/care-services',
    name: 'Care Services',
    header: true,
  },
  {
    path: '/child-care',
    name: 'Child Care',
  },
  {
    path: '/home-care',
    name: 'Home Care',
  },
  {
    path: '/pet-care',
    name: 'Pet Care',
  },
  {
    path: '/elder-care',
    name: 'Elder Care',
  },
  {
    path: '/payroll-services',
    name: 'Payroll Service',
    header: true,
    line: true,
  },
  {
    path: '/about',
    name: 'Company',
    header: true,
    line: true,
  },
  {
    path: '/team',
    name: 'Our Team',
  },
  {
    path: '/news-ideas',
    name: 'News & Ideas',
  },
  {
    path: '/branding',
    name: 'Brand Assets',
  },
  {
    path: '/careers',
    name: 'Work With Us',
  },
  {
    path: '/contact',
    name: 'Contact',
    header: true,
    line: true,
  },
]

const menuItems = menu && menu.length > 0 && menu.map((item, index) => {
  return <MobileNavItem key={index} delay={`${index * 0.05}s`} {...item} />
})

function MobileNav(props) {
  return (
    <RawMobileNav {...props}>
      <FlexContainer
        direction='column'
        justifyContent='space-around'
        id='mobile-nav-links'
        className={props.open ? 'open' : null}
      >
        <div className='mobileMenuBoundingBox'>{props.open ? menuItems : null}</div>
      </FlexContainer>
    </RawMobileNav>
  )
}

MobileNav.propTypes = {
  open: PropTypes.bool,
}

export default MobileNav
